import React from 'react';

interface TreasuryModalProps {
  treasury: number;
  onClose: () => void;
  onUpdate: (newValue: number) => void;
}

export const TreasuryModal: React.FC<TreasuryModalProps> = ({ treasury, onClose, onUpdate }) => {
  const STEP = 5000;

  const decrement = () => onUpdate(Math.max(0, treasury - STEP));
  const increment = () => onUpdate(treasury + STEP);

  const handleDirectInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/,/g, '');
    const num = parseInt(raw, 10);
    if (!isNaN(num)) onUpdate(num);
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: '#fff', borderRadius: '12px', padding: '28px',
          width: '90%', maxWidth: '380px', boxSizing: 'border-box',
          boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '20px' }}>
          <div>
            <h3 style={{ margin: '0 0 4px 0', fontSize: '18px', color: '#0f172a' }}>Treasury</h3>
            <p style={{ margin: 0, fontSize: '13px', color: '#64748b' }}>Adjust in 5,000 gp increments</p>
          </div>
          <button
            onClick={onClose}
            style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#94a3b8', padding: '0 4px' }}
          >
            ×
          </button>
        </div>

        {/* Counter */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '20px', marginBottom: '24px' }}>
          <button
            onClick={decrement}
            disabled={treasury <= 0}
            style={{
              width: '44px', height: '44px', borderRadius: '50%',
              border: '2px solid #e2e8f0', background: treasury <= 0 ? '#f1f5f9' : '#fff',
              fontSize: '22px', fontWeight: 'bold', cursor: treasury <= 0 ? 'not-allowed' : 'pointer',
              color: treasury <= 0 ? '#cbd5e1' : '#0f172a',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            −
          </button>

          <div style={{ textAlign: 'center' }}>
            <input
              type="text"
              value={treasury.toLocaleString()}
              onChange={handleDirectInput}
              style={{
                width: '140px', textAlign: 'center', padding: '8px 10px',
                border: '1px solid #cbd5e1', borderRadius: '8px',
                fontSize: '22px', fontWeight: 'bold',
                color: treasury >= 0 ? '#16a34a' : '#dc2626',
                outline: 'none',
              }}
            />
            <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '4px' }}>gp</div>
          </div>

          <button
            onClick={increment}
            style={{
              width: '44px', height: '44px', borderRadius: '50%',
              border: '2px solid #e2e8f0', background: '#2563eb',
              fontSize: '22px', fontWeight: 'bold', cursor: 'pointer',
              color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}
          >
            +
          </button>
        </div>

        <button
          onClick={onClose}
          style={{
            width: '100%', padding: '12px', background: '#0f172a',
            color: '#fff', border: 'none', borderRadius: '8px',
            fontSize: '15px', fontWeight: '600', cursor: 'pointer',
          }}
        >
          Done
        </button>
      </div>
    </div>
  );
};
